export default "__VITE_ASSET__BLFvqQJg__"